import { getAPIDataReturn } from "../../../utils/apiFunction";

const getCreditMemoStock = async (id, abortController, setLoading, setData) => {
    setLoading(true);
    const uri = process.env.REACT_APP_BASE_URL;    
    const response = await getAPIDataReturn(('/CreditMemo/GetLines/' + id), abortController);
    setData(response);
    setLoading(false);
}

export default getCreditMemoStock;